import i18n from '@/i18n'
import $ from 'jquery';
import { mapGetters, mapMutations } from 'vuex'

import { EventBus } from '@/app/shared/services/event-bus.js';
import appConfig from '@/app/shared/config/app-config.json'
import config from "@/app/physician-portal/physician-desktop/shared/config/PHD-config.json";


// SERVICES NEEDED 
import { loginService } from '@/app/shared/services/loginService.js';
import { modelServices } from '@/app/shared/services/client-agent-service.js';
import { KendoServiceForPatientSearch } from '@/app/shared/services/kendo-service/kendoService.js';
import { patientSearchService } from '@/app/shared/layouts/services/searchPatient.js';
import { notificationService } from '@/app/shared/layouts/services/notification-service.js'
import { NotificationUrl } from '@/app/shared/layouts/services/notification-url.js';



// COMPONENTS NEEDED 
import capturePatient from '@/app/physician-portal/physician-desktop/shared/capture-patient/capture-patient.vue'
import notificationCardTemplate from './notification-card-template/notification-card-template.vue'
import Loader from '@/app/shared/layouts/components/loader/loader.vue';
import AutoCatchBarcodeScanner from "@/app/shared/components/barcode-scanner/auto-catch-barcode-scanner.vue";


export default {
    name: "profile-bar",
    data() {
        return {
            //  --------------------------- START MAIN APP DATA SECTION  --------------------------- 
            NG_TRANSLATE_LANG_KEY: '',
            selectedLang: localStorage.getItem('NG_TRANSLATE_LANG_KEY'),
            userName: localStorage.getItem('DisplayName'),
            isLoading: false,
            showLogout: localStorage.getItem('isFormAuthenticated') == "true",
            //  --------------------------- END MAIN APP DATA SECTION  --------------------------- 


            //  --------------------------- START NOTIFICATION SECTION  --------------------------- 
            isNotificationsPopupOpened: false,
            hasReceiveNotificationsPermission: modelServices.ifUserHasPermission('Receive Notifications', null),
            isNotificationsEnabled: null,
            notificationsConnection: null,
            NotificationsListDataSource: null,
            isLoadingNotifications: false,
            isAllNotificationsLoaded: false,
            notificationsToBeReadCount: 0,

            languages: [
                {
                    language: 'en',
                    title: this.$i18n.t('Common.En')
                },
                {
                    language: 'ar',
                    title: this.$i18n.t('Common.Ar')
                }
            ],

            //  --------------------------- END NOTIFICATION SECTION  --------------------------- 



            //  --------------------------- START UNIVERSAL SEARCH SECTION  --------------------------- 
            //Grid datasource
            PatientListOptions: [],
            wantToSearch: false,
            // Check if universal search input is Focused or not 
            txtBoxFocused: false,
            // Flag for view the universal search
            searchPatient: true,
            condAddEdit: false,
            LoadRegisterNewPatient: false,
            inputLoader: false,

            userEntities: [],
            selectedEntity: '',
            searchPatientsField: '',
            selectedPatientCode: null,
            PatientObj: {},
            sendData: {},

            url: '',
            oldMedicalURL: "",

            pagingIncrement: 20,
            currentPage: null,

            keyOld: null,
            keyNew: null,
            oldElement: null,

            columns: [
                {
                    field: "",
                    title: "",
                    width: 70,
                    sortable: false,
                    filterable: false,
                    template: function (dataItem) {

                        dataItem.EnFullName = dataItem.EnFullName.replace(/\s\s+/g, ' ');// replace more than spaces between words with only one space
                        dataItem.ArFullName = dataItem.ArFullName.replace(/\s\s+/g, ' ');// replace more than spaces between words with only one space
                        if (localStorage.getItem('NG_TRANSLATE_LANG_KEY') === "en") {// to detect language
                            if (dataItem.Age == "" || dataItem.Age == null || dataItem.Age == undefined)
                                dataItem.Age = "Unknown Age";
                            if (dataItem.Code == "" || dataItem.Code == null || dataItem.Code == undefined)
                                dataItem.Code = "Unknown Code";
                            if (dataItem.EnFullName.trim() == "") dataItem.EnFullName = "Unknown Name";
                            else if (dataItem.EnFullName == null || dataItem.EnFullName == undefined)
                                dataItem.FullName = "Unknown Name";
                            if (dataItem.MainPhone == "" || dataItem.MainPhone == null || dataItem.MainPhone == undefined)
                                dataItem.MainPhone = "Unknown Phone";

                            dataItem.FullName = dataItem.EnFullName;

                        }
                        else if (localStorage.getItem('NG_TRANSLATE_LANG_KEY') === "ar") {
                            if (dataItem.Age == "" || dataItem.Age == null || dataItem.Age == undefined)
                                dataItem.Age = "العمر غير معروف";
                            if (dataItem.Code == "" || dataItem.Code == null || dataItem.Code == undefined)
                                dataItem.Code = "الكود غير معروف";
                            if (dataItem.ArFullName.trim() == "") dataItem.ArFullName = "الاسم غير معروف";
                            else if (dataItem.ArFullName == null || dataItem.ArFullName == undefined)
                                dataItem.ArFullName = "الاسم غير معروف";
                            if (dataItem.MainPhone == "" || dataItem.MainPhone == null || dataItem.MainPhone == undefined)
                                dataItem.MainPhone = "رقم الهاتف غير معروف";

                            dataItem.FullName = dataItem.ArFullName;

                        }
                        return this.itemStrucure(dataItem)
                    }.bind(this)
                }
            ]
            //  --------------------------- END UNIVERSAL SEARCH SECTION  --------------------------- 

        }
    },

    created() {
        this.LoadFromSessionStorage();
        this.oldMedicalURL = localStorage["MedicalBase"] + config.oldMedicalURL;
        this.condAddEdit = this.showHideElement('UpdatePatientDataFromUniversalSearch');
        EventBus.$on('setAutoCatchBarcodevalue', barcode => {
            this.inputLoader = true
            // this.searchPatientsField = barcode
            console.log(barcode) 

            patientSearchService.GetPatientByCode(barcode,
                (result) => {
                    console.log(result.data)
                    let getPatientByBarcode = result.data.value.find(x => x.Code == barcode)
                    console.log(getPatientByBarcode);

                    this.selectPatient(getPatientByBarcode)
                    EventBus.$emit('autoCapturePatient');

                    this.inputLoader = false 
                },
                (error) => {
                    console.error(error, "Error Message");
                    this.inputLoader = false 
                });
        })

    },
    methods: {
        //  --------------------------- START MAIN APP FUNC SECTION  --------------------------- 
        ...mapMutations(['setNotificattions', 'setNotificationsCounter']),

        showHideElement(clientAction) {
            return modelServices.ifUserHasPermission(clientAction, 'app.dashboard');
        },
        changeLocale(locale) {
            EventBus.$emit('ShowLoader');
            var _localStorageData = {};
            _localStorageData.isChangeLang = true;
            _localStorageData.NG_TRANSLATE_LANG_KEY = locale;
            _localStorageData.messageOrigin = window.origin;
            document.getElementById('idMyIframe').contentWindow.postMessage(_localStorageData, '*');
            loginService.changeUserLang(locale == 'ar', null, (result) => {

                if (result != null && result.data.ResponseStatus == 200 && result.data.token != null) {
                    i18n.locale = locale;
                    localStorage.setItem('NG_TRANSLATE_LANG_KEY', locale);
                    result.data.token.NG_TRANSLATE_LANG_KEY = locale;
                    loginService.saveTokenInfo(result.data.token);

                    setTimeout(() => {
                        location.reload(); // would completely destroy all stored states, including WebSocket connections
                    }, 200);
                }
                else {
                    //loginService.test();
                    alert("*****fail****");
                    console.log("***********Fail********");
                }
                EventBus.$emit('MedicalChangeLang');

                EventBus.$emit('HideLoader');
            }, (error) => {
                console.log("***********Fail********");
                console.log(error);
                EventBus.$emit('HideLoader');
            });
        },
        changeSharedEntity(entityId) {
            EventBus.$emit('ShowLoader');
            var _localStorageData = {};
            localStorage.setItem("sharedEntityId", entityId);
            _localStorageData.isChangeLang = true;
            _localStorageData.NG_TRANSLATE_LANG_KEY = localStorage.getItem("NG_TRANSLATE_LANG_KEY");
            _localStorageData.messageOrigin = window.origin;
            document.getElementById('idMyIframe').contentWindow.postMessage(_localStorageData, '*');
            loginService.changeUserLang(localStorage.getItem("NG_TRANSLATE_LANG_KEY") == 'ar', entityId, (result) => {

                if (result != null && result.data.ResponseStatus == 200 && result.data.token != null) {
                    i18n.locale = localStorage.getItem("NG_TRANSLATE_LANG_KEY");
                    localStorage.setItem('NG_TRANSLATE_LANG_KEY', localStorage.getItem("NG_TRANSLATE_LANG_KEY"));
                    result.data.token.NG_TRANSLATE_LANG_KEY = localStorage.getItem("NG_TRANSLATE_LANG_KEY");
                    loginService.saveTokenInfo(result.data.token);

                    setTimeout(() => {
                        location.reload(); // would completely destroy all stored states, including WebSocket connections
                    }, 200);

                }
                else {
                    alert("*****fail****");
                    console.log("***********Fail********");
                }
                EventBus.$emit('MedicalChangeLang');

                EventBus.$emit('HideLoader');
            }, (error) => {
                console.log("***********Fail********");
                console.log(error);
                EventBus.$emit('HideLoader');
            });
        },
        changePassword() {
            this.$router.push('/change-password');
        },
        logout() {
            if (localStorage["user"] != null) {

                loginService.logout(localStorage["user"], () => {
                    localStorage.clear();
                    sessionStorage.clear();
                     document
                    .getElementById("idMyIframe")
                         .contentWindow.postMessage({ ClearAllDataInAngular :true} , "*");

                    window.location.href = window.location.origin;
                });
            }
            else {
                localStorage.clear();
                sessionStorage.clear();
                this.$router.push("/");
                document.getElementById('idMyIframe').contentWindow.postMessage({ ClearAllDataInAngular: true }, '*');
            }
        },
        bindEvent: function (element, eventName, eventHandler) {

            if (eventName == 'Remove') {
                element.removeEventListener('click', eventHandler);
            }
            else if (element.addEventListener) {
                element.addEventListener(eventName, eventHandler, false);
            } else if (element.attachEvent) {
                element.attachEvent('on' + eventName, eventHandler);
            }
        },
        //  --------------------------- END MAIN APP FUNC SECTION  --------------------------- 


        //  ------------------------------------------------------------------------------------
        //  ------------------------------------------------------------------------------------

        //  --------------------------- START UNIVERSAL SEARCH FUNC SECTION  --------------------------- 

        //Capture button state 
        CheckDisplayCapturePatientBtn() {
            if (this.$router.currentRoute.fullPath.startsWith("/physicianDesktop") || this.$router.currentRoute.fullPath.startsWith("/pharmacy")) {
                var triggerSearchValue = null
                if (this.PatientObj) {
                    triggerSearchValue = this.searchPatientsField
                        == (
                            (this.selectedLang === "en")
                                ? this.PatientObj.EnFullName
                                : this.PatientObj.ArFullName
                        )
                }
                //do something when the data changes.
                if (!triggerSearchValue) {
                    $('.capture-btn')[0].classList.add("disabledClick");
                    $('.capture-btn')[0].setAttribute("disabled", "disabled");
                }
                else {
                    $('.capture-btn')[0].classList.remove("disabledClick");
                    $('.capture-btn')[0].removeAttribute("disabled")
                }
            }
        },

        // Make the input of search patient focused
        focusInput() {
            $("#searchPatientsFieldControl").focus();
        },
        // When user outfocused the input set txtBoxFocused = false
        blurInput() {
            if (!$(".searchInput").val()) {
                this.txtBoxFocused = false
            }
        },

        // Keyboard navigation section
        // save previous key pressed "keyOld" and current key pressed "keyNew" to check if he pressed alt+s --> select patient
        // save old heighligted record "oldElement"
        navigatewithArrows(e) { //when key is pressed
            this.oldElement = $(".listitem-active"); // get heighligted element
            this.keyOld = this.keyNew; // get the previous key pressed
            this.keyNew = e.keyCode; // get the current key pressed
            //select heightlighted record
            if (this.keyOld == 18 && this.keyNew == 83) { // 18 -- alt & 83 -- s
                var data = $("#PatientList").data("kendoGrid").dataItem("tr.active-parent"); // get dataitem of heightlgted one
                this.selectPatient(data); // select the patient
            }
            else {
                if (this.keyNew == 40) { // down arrow
                    if (this.oldElement.parents("tr").next().length > 0) {
                        //remove heighlight from current record
                        this.oldElement.removeClass("listitem-active");
                        this.oldElement.parents("tr").removeClass("active-parent");
                        //heighlight next "down" record
                        this.oldElement.parents("tr").next().find(".listitem").addClass("listitem-active");
                        this.oldElement.parents("tr").next("tr").addClass("active-parent");
                    }
                    // scroll down 
                    if (this.oldElement.position()) {

                        // scroll to the bottom of the last heighlighted record " top of current "
                        // -50 to make the heighlighted record in midle of search area not the first one

                        console.log($('#PatientList .k-grid-content.k-auto-scrollable').scrollTop())
                        console.log(this.oldElement.position().top)
                        console.log(this.oldElement.height())

                        $('#PatientList .k-grid-content.k-auto-scrollable').animate({
                            scrollTop: $('#PatientList .k-grid-content.k-auto-scrollable').scrollTop() + this.oldElement.height() + 5
                        },
                            'slow')

                    }
                }
                else if (this.keyNew == 38) { // up arrow
                    if (this.oldElement.parents("tr").prev().length > 0) {
                        //remove heighlight from current record
                        this.oldElement.removeClass("listitem-active");
                        this.oldElement.parents("tr").removeClass("active-parent");
                        //heighlight previous "up" record
                        this.oldElement.parents("tr").prev().find(".listitem").addClass("listitem-active");
                        this.oldElement.parents("tr").prev("tr").addClass("active-parent");
                    }
                    //scroll up
                    if (this.oldElement.position() && this.oldElement.parents("tr").prev("tr").position()) {


                        if (this.oldElement.parents("tr").prev("tr").position().top < 0 || this.oldElement.parents("tr").prev("tr").position().top > 200) {

                            $('#PatientList .k-grid-content.k-auto-scrollable').animate({
                                scrollTop: $('#PatientList .k-grid-content.k-auto-scrollable').scrollBottom() + this.oldElement.parents("tr").prev("tr").position().top - 5
                            }, 'slow')
                            // don`t scroll unless the heighlighted record becomed out of search area boundaries
                            // $('#PatientList .k-grid-content.k-auto-scrollable').scrollTop($('#PatientList .k-grid-content.k-auto-scrollable').scrollTop() + this.oldElement.parents("tr").prev("tr").position().top - 100);
                        }
                    }
                }
            }
        },

        // Add click event on card to select patient & on edit icon to edit patient
        addEventListenerSearch() {

            var elements = document.getElementsByClassName("listitem")
            if (elements.length) {
                for (var i = 0; i < elements.length; i++) {
                    elements[i].addEventListener("click", this.clickedPatient);
                    if ($('.editPatientBtn')[i]) {
                        $('.editPatientBtn')[i].addEventListener("click", this.clickEditPatient)
                    }
                    // Code  Name Age PhoneNumber 
                    let removePointerDiv = [$('.Code')[i], $('.Name')[i], $('.PhoneNumber')[i]]
                    for (var x = 0; x < removePointerDiv.length; x++) {
                        removePointerDiv[x].addEventListener('click', function (e) {
                            e.stopPropagation();
                        });
                    }
                }
            }
        },
        // When user click enter to search 
        isEnterClicked(e) {  
            if (e.fromScanner) {
                e.preventDefault()
            }
            else if (e.keyCode === 13) {
                e.preventDefault()
                this.getPatients();
                this.searchPatientClicked()
            }
        },
        // On click patient card
        clickedPatient(e) {
            let grid = $("#PatientList").getKendoGrid();
            let item = grid.dataItem($(e.target).closest("tr"));
            this.selectPatient(item);
        },

        // When click on register new patient button
        RegisterNewPatient: function (e) {
            e.preventDefault();
            e.stopPropagation();
            this.hidePopup(); // close the search results area

            this.LoadRegisterNewPatient = true;
            this.sendData = {};
            this.sendData.isAddPatient = true;

            var iframe = document.getElementById('oldMedicalURL');
            iframe.src = this.oldMedicalURL;
            this.load();
            var window = this.$refs.oldRef.kendoWidget();
            window.content = this.oldMedicalURL;

            setTimeout(() => {
                window.center().open();
            })
        },
        // When click on edit patient icon
        clickEditPatient(e) {
            let grid = $("#PatientList").getKendoGrid();
            let item = grid.dataItem($(e.target).closest("tr"));
            this.editPatient(item);
        },
        editPatient: function (dataItem) {
            this.hidePopup(); // close the search results area
            console.log(dataItem)
            this.LoadRegisterNewPatient = true
            this.sendData = {};
            this.sendData = dataItem;
            this.sendData.isEditPatient = true;
            var iframe = document.getElementById('oldMedicalURL');
            iframe.src = this.oldMedicalURL;
            this.load();
            var window = this.$refs.oldRef.kendoWidget();
            window.content = this.oldMedicalURL;
            setTimeout(() => {
                window.center().open();
            })
        },
        // Render the iframe from old medical in case New/Edit patient
        load: function () {
            this.LoadRegisterNewPatient = true;
            this.sendData.PatientObj = JSON.parse(JSON.stringify(this.PatientObj));
            var obj = JSON.parse(JSON.stringify(this.sendData));
            document.getElementById('oldMedicalURL').contentWindow.postMessage(obj, '*');
            document.getElementById("register-window-parent").parentElement.classList.add("register-window-parent-div")
        },


        // Before call service set default behaviour When user click enter to search 
        getPatients() {
            this.wantToSearch = true;
            $("#searchPatientsFieldControl").focus();
            this.txtBoxFocused = true
            this.$root.$emit("SearchFocusedcloseList")
        },
        // Before call service set default behaviour 
        // Called after set some behaviours when click enter OR Called direct when user click search icon 
        searchPatientClicked() {
            if (this.searchPatientsField != "") {
                this.$root.$emit("SearchFocusedcloseList")
                this.$root.$emit("CloseNavBar")

                setTimeout(() => {
                    this.txtBoxFocused = false
                    this.showPopup();
                    this.CallPatientDataSource();
                })
            }
            else {
                this.hidePopup()
            }
        },
        // Data Source of Universal Search Patient List
        CallPatientDataSource() {
            var dataSource = $("#PatientList").data("kendoGrid").dataSource;
            this.searchPatientsField = this.searchPatientsField.trim();

            if (this.searchPatientsField == "")
                return;

            if (dataSource)
                //There is Stored Patient in session storage
                if ((this.selectedPatientCode != ""
                    && this.selectedPatientCode != null
                    && this.selectedPatientCode != undefined
                    && this.searchPatientsField) && this.PatientObj) {
                    if (this.selectedLang === "en") {// to check if patient aleardy selected then check if it in the storage is null
                        if (this.PatientObj.EnFullName == null)
                            this.PatientObj.EnFullName = "";
                    }
                    else {
                        if (this.PatientObj.ArFullName == null)
                            this.PatientObj.ArFullName = "";
                    }
                    if (
                        (

                            (this.searchPatientsField == (
                                (this.selectedLang === "en")
                                    ? this.PatientObj.EnFullName
                                    : this.PatientObj.ArFullName)
                            )
                            || this.searchPatientsField == "Unknown Name"
                        )
                        && (typeof (Storage) !== "undefined"
                            && (sessionStorage.patient) != undefined)
                    )
                        this.url = patientSearchService.GetPatientSearchOdataList + "?searchKey=&Code=" + encodeURIComponent(this.selectedPatientCode);
                    else
                        this.url = patientSearchService.GetPatientSearchOdataList + "?searchKey=" + encodeURIComponent(this.searchPatientsField) + "&Code="
                }
                else this.url = patientSearchService.GetPatientSearchOdataList + "?searchKey=" + encodeURIComponent(this.searchPatientsField) + "&Code="
            if (this.url) {
                let patientList = new KendoServiceForPatientSearch
                    (this.url, this.pagingIncrement, "PatientID",
                        {
                            PatientID: { type: "number" },
                            Code: { type: "string" },
                            FullName: { type: "string" },
                            Age: { type: "string" },
                            EnFullName: { type: "string" },
                            ArFullName: { type: "string" },

                        }, "SortingName", true, "asc", true);

                this.PatientListOptions = patientList.data;

            }
        },


        setPatientToStorage: function (EnFullName, ArFullName, DateOfBirth, MainPhone, Code, Gender, TimeStamp, PatientID) {

            this.SetPatientObj(EnFullName, ArFullName, DateOfBirth, MainPhone, Code, Gender, TimeStamp, PatientID);

            if (this.PatientObj) {

                this.searchPatientsField = "";

                this.searchPatientsField =
                    (this.selectedLang === "en")
                        ? (this.PatientObj.EnFullName != null
                            && this.PatientObj.EnFullName != undefined
                            && this.PatientObj.EnFullName != "")
                            ? this.PatientObj.EnFullName
                            : "Unknown Name"

                        : (this.PatientObj.ArFullName != "")
                            ? this.PatientObj.ArFullName
                            : "الاسم غير معروف"
                this.selectedPatientCode = this.PatientObj.Code;

                return modelServices.addDataSessionCache("patient", this.PatientObj);
            }


        },
        SetPatientObj(EnFullName, ArFullName, DateOfBirth, MainPhone, Code, Gender, TimeStamp, PatientID) {

            this.PatientObj = {
                EnFullName: (EnFullName.trim() == "" || EnFullName == "Unknown Name") ? null : EnFullName,
                ArFullName: (ArFullName.trim() == "") ? null : ArFullName,
                DateOfBirth: ((DateOfBirth) ? (DateOfBirth.substring(0, DateOfBirth.indexOf("+"))) : null),
                MainPhone: (MainPhone == "Unknown Phone" || MainPhone == "رقم الهاتف غير معروف") ? null : MainPhone,
                Code: (Code == "Unknown Code" || Code == "الكود غير معروف") ? null : Code,
                Gender: Gender,
                TimeStamp: TimeStamp,
                PatientID: PatientID
            }



        },
        LoadFromSessionStorage() {
            if (typeof (Storage) !== "undefined") {
                if (sessionStorage.patient) {
                    setTimeout(() => {
                        var PatientObj = JSON.parse(sessionStorage.patient);
                        //this.PatientID = PatientObj.PatientID;
                        this.PatientObj = PatientObj;
                        this.searchPatientsField = (this.selectedLang === "en") ? ((this.PatientObj.EnFullName == null) ? "Unknown Name" : this.PatientObj.EnFullName)
                            : ((this.PatientObj.ArFullName == null) ? "الاسم غير معروف" : this.PatientObj.ArFullName);
                        // $(".searchInput").addClass("invisibleTxtBox");
                        //  this.PatientID = this.PatientObj.PatientID;
                        this.selectedPatientCode = this.PatientObj.Code;
                        this.$root.$emit('capturedPatient', this.PatientObj)
                        $(".selectedPatient").removeClass("hidden"); // to show selected patient div "UI"

                    });

                }
                else {
                    this.searchPatientsField = "";
                    this.PatientObj = null;
                    this.selectedPatientCode = null;
                    this.hideSelectionBox(true);
                    $(".searchInput").blur();
                }
            }


            this.userEntities = JSON.parse(localStorage.getItem("sharedUserEntities"));

            if (localStorage.getItem("sharedEntityId")) {
                this.selectedEntity = parseInt(localStorage.getItem("sharedEntityId"));
            }
            else if (!localStorage.getItem("sharedEntityId") && JSON.parse(localStorage.getItem("sharedUserEntities")).length > 0) {
                this.selectedEntity = JSON.parse(localStorage.getItem("sharedUserEntities"))[JSON.parse(localStorage.getItem("sharedUserEntities")).length - 1].EntityID;
            }
        },
        // Save Patient ID To session Storage and bind selected one to the textbox...
        selectPatient(patient) {
            this.$root.$emit('capturedPatient', patient)
            this.setPatientToStorage(patient.EnFullName, patient.ArFullName, patient.DOB, patient.MainPhone, patient.Code, patient.Gender, patient.PatientTimeStamp, patient.PatientID);

            // setPatientToStorage in old Medical
            this.PatientObj.setPatientToStorage = true;
            document.getElementById('oldMedicalURL').contentWindow.postMessage(this.PatientObj, '*');
            this.hidePopup();
            this.CheckDisplayCapturePatientBtn();
        },
        // Cancel selection & clear catched patient from session storage
        hideSelectionBox(isfocused) {
            $(".selectedPatient").addClass("hidden");
            this.searchPatientsField = '';
            this.hidePopup();
            if (isfocused != true) {
                setTimeout(() => {
                    $(".searchInput").focus();
                    this.txtBoxFocused = true
                });  //keep timeout to focus-- it didn`t work without it
            } else {
                this.txtBoxFocused = false
            }
            if (document.getElementById("idMyIframe")) {
                document
                    .getElementById("idMyIframe")
                    .contentWindow.postMessage("RemoveCapturedPatient", "*");
            }
            this.$root.$emit("ClearCapturedPatient");
            this.PatientObj = null;
            this.selectedPatientCode = null;
            return modelServices.clearDataSessionCache("patient");
        },


        // Build HTML of data item of the grid...
        itemStrucure(dataItem) {

            if (!dataItem.Gender) dataItem.Gender = "";
            let femaleIcon = "<img src='" + `${require('@/assets/svg/female-icon.svg')}` + "'/>"
            let maleIcon = "<img src='" + `${require('@/assets/svg/male-icon.svg')}` + "'/>"
            let editIcon = "<img src='" + `${require('@/assets/svg/ic_edit.svg')}` + "'/>"
            var itemHTML = `
            ${dataItem.ColorCode == ""
                    ? '<div class="listitem mb5">'
                    : '<div class="listitem mb5" style="border-left: 5px solid ' + dataItem.ColorCode + '">'
                }
        
        <div class="row"> 
          <div class="col-md-1">
            <div class="gender">
                     <div class='img-gender'>

        ${dataItem.Gender.toLowerCase() == "female"
                    ? femaleIcon
                    : ''
                }
        ${dataItem.Gender.toLowerCase() == "male"
                    ? maleIcon
                    : ''
                }

       ${dataItem.Gender.toLowerCase() == "unspecified"
                    ? ' <i class="fa fa-ban"></i> '
                    : ''
                } 
        ${!dataItem.Gender.toLowerCase()
                    ? '<span class="noGender"></span>  '
                    : ''
                } 
    
      </div>

          </div>
         </div>

         <div class="col-md-11"> 
 
        <div class="row"> 
        <div class="col-md-12">
        <div class="Code"> 

        ID , ${dataItem.Code}
        </div> 
        </div>
        </div> 
        <div class="row"> 
        <div class="col-md-6">
        <div class="Name mr20">
       ${dataItem.FullName
                    ? dataItem.FullName.toLowerCase()
                    : ''
                }
               </div> 

        </div> 
        <div class="col-md-4">
        <div class="mb5">
           <div class="Age ">${dataItem.Age}  </div> 
        </div> 
        </div> 
        <div class="col-md-2">
        ${this.condAddEdit ?
                    ' <div class="editPatientBtn">' + editIcon + '</div>'
                    : ''
                }
        </div> 
         </div>

          <div class="row"> 
        <div class="col-md-6">
             <div class="PhoneNumber ">
             <i class="fas fa-phone-alt"></i>
             ${dataItem.MainPhone}
             </div>
            </div> 
         </div>
        </div>
    </div>
   </div> 
       `

            // '<span class="noGender"></span>'
            // show-and-hideaction="UpdatePatientDataFromUniversalSearch">
            // @click="editPatient(dataItem)"
            // var itemHTML =
            //tooltip="{{\'common.Edit\' |translate}}" tooltip-placement="bottom" tooltip-popup-delay="500"
            return itemHTML;
        },
        noRecordTemplate: function () {

            $('#PatientList').height(200)
            return `
        <div class="norecords-template">
          <div class="row">
           <div class="col-md-3">
            <img class="nodata-img" src=${require('@/assets/svg/noDataFound.svg')} /> 
           </div>
           <div class="col-md-9">
            <div class="head-no-record">
             ${this.$i18n.t('Common.NoDataToDisplay')}
            </div>
            <span class="body-no-record">
              <span> ${this.$i18n.t('Common.Try')}</span>
              <span class="bold"> ${this.$i18n.t('Common.DifferentKeywords')}</span>
             </span>
             <span class="body-no-record">
              <span> ${this.$i18n.t('Common.Or')}</span>
              <span class="bold"> ${this.$i18n.t('Common.RemoveSearchFilters')}</span>
             </v>
           </div>
          </div>
         </div>`;
        },
        onDataBound: function (e) {
            // heighlight first record into any loaded page
            setTimeout(() => {
                this.addEventListenerSearch();

                var grid = $("#PatientList").data("kendoGrid");

                var index = 0;
                // make first record heighlighted when press enter or click into search button -- sometimes it was not heighlighted without this condition
                if (this.wantToSearch) {
                    grid.tbody.find("tr").first().addClass("active-parent");
                    grid.tbody.find(".listitem").first().addClass("listitem-active");
                    this.wantToSearch = false;
                }
                // if scroll up
                else if (this.currentPage > e.sender.dataSource.page()) {
                    for (index = grid.dataSource._view.length - 1; index > -1; index--) {
                        //get last one visible
                        if (grid.tbody.find("tr").eq(index).position().top >= 0) { // get first element visible into the search area
                            // remove old heighlighted record
                            $(".listitem-active").removeClass("listitem-active");
                            $(".active-parent").removeClass("active-parent");

                            grid.tbody.find("tr").eq(index).prev().find(".listitem").addClass("listitem-active");
                            grid.tbody.find("tr").eq(index).prev().addClass("active-parent");
                            break;
                        }
                    }
                }
                else {
                    for (index = 0; index < grid.dataSource._view.length; index++) {
                        //get first one visible
                        if (grid.tbody.find("tr").eq(index).position().top >= 0) {// get first element visible into the search area
                            // remove old heighlighted record
                            $(".listitem-active").removeClass("listitem-active");
                            $(".active-parent").removeClass("active-parent");

                            grid.tbody.find("tr").eq(index).find(".listitem").addClass("listitem-active");
                            grid.tbody.find("tr").eq(index).addClass("active-parent");
                            break;
                        }
                    }
                }
                this.currentPage = e.sender.dataSource.page();
            });
        },

        showPopup() {
            if (this.searchPatientsField) {
                $(".popupPatients").slideDown(100);
            }
        },
        hidePopup() {
            $(".popupPatients").slideUp(150);
        },
        //  --------------------------- END UNIVERSAL SEARCH FUNC SECTION  --------------------

        //  ------------------------------------------------------------------------------------
        //  ------------------------------------------------------------------------------------


        //  --------------------------- START NOTIFICATIONS FUNC SECTION  --------------------------- 
        clickNotification() {
            this.$root.$emit("CloseNavBar")
        },

        // scroll event for notifications list dropdown 
        onScroll({ target: { scrollTop, clientHeight, scrollHeight } }) {
            console.log(scrollTop, "scrollTop");
            console.log(clientHeight, "clientHeight");
            console.log(scrollHeight, "scrollHeight");
            if (scrollTop + clientHeight >= scrollHeight) {
                // loading notification list
                this.loadNextPageNotifications();
            }
        },
        // loading notification list
        loadNextPageNotifications() {
            if (this.isLoadingNotifications || this.isAllNotificationsLoaded /* || !this.odataVisitCount || this.odataVisitCount == this.numLoadedVisits*/)
                return;

            this.getNotifications();
        },
        // remove all dropdown click listener when go from screen 
        removeNotificationMenuIconClick() {
            $(document).off("click", ".menu.menuNotification");
            window.removeEventListener('click', this.documentClickHandler, false);
        },

        //Remove dropdown when click outside on DOM
        documentClickHandler(event) {
            var $trigger = $(".dropdown.dropdownNotification");
            if (event != null && $trigger !== event.target &&
                !$trigger.has(event.target).length) {
                this.CloseNSPopover();
            }
        },
        CloseNSPopover() {
            if (this.isNotificationsPopupOpened && this.isNotificationsButtonShown) {
                $(".dropdown-menu").removeClass('show');
                this.isNotificationsPopupOpened = false;
            }
        },

        // open dropdown when click
        NotificationMenuIconClick() {
            var that = this;
            $(document).on("click", ".menu.menuNotification", function () {
                debugger;
                let hasClass = $(this).closest(".menuNotification").closest('.dropdown').find('.dropdown-menu').hasClass('show');
                if (hasClass) {
                    $(this).closest(".dropdown.dropdownNotification").find('.dropdown-menu').removeClass('show');
                    that.isNotificationsPopupOpened = false;
                } else {
                    $(".dropdown-menu").removeClass("show");
                    $(this).closest(".dropdown.dropdownNotification").find('.dropdown-menu').addClass('show');

                    that.notificationsToBeReadCount = that.getNotificationsCounter;
                    that.isNotificationsPopupOpened = true;
                }
            });
        },
        async getTicketAndConnectToNotificationsServiceAsync() {
            if (this.hasReceiveNotificationsPermission == false)
                return;

            let updatedTicketResult = await notificationService.GetUpdatedTicketPromise();
            if (updatedTicketResult?.data) {
                this.isNotificationsEnabled = updatedTicketResult.data.IsNotificationsEnabled;

                if (updatedTicketResult.data.IsNotificationsEnabled) {
                    this.connectToNotificationsService(updatedTicketResult.data.TicketHash);

                    this.getNotifications();
                    this.getUnreadNotificationsCount();
                }
            }
        },
        connectToNotificationsService(ticket) {
            let that = this;
            let url = notificationService.GetNotificationWebSocketConnectUrl(ticket);
            this.notificationsConnection = new WebSocket(url);

            this.notificationsConnection.onmessage = function (event) {
                console.log("Notification Received", "Notifications Socket");

                let notification = JSON.parse(event.data);

                if (notification.AlertSoundURL != null) {
                    notification.AlertSoundURL = NotificationUrl.NotificationBaseUrl + notification.AlertSoundURL;
                }

                if (notification.IconURL != null) {
                    notification.IconURL = NotificationUrl.NotificationBaseUrl + notification.IconURL;
                }

                EventBus.$emit("FireNotification", notification);
                that.addNotificationToList(notification);
            };

            this.notificationsConnection.onopen = function (/*event*/) {
                console.log("Notifications Socket Opened", "Notifications Socket");
            };

            this.notificationsConnection.onclose = function (/*event*/) {
                console.log("Notifications Socket Closed", "Notifications Socket");

                setTimeout(that.getTicketAndConnectToNotificationsServiceAsync, 1000);
            };
        },
        getNotifications() {
            this.isLoadingNotifications = true;

            notificationService.GetNotificationODataPromise(appConfig.notificationsListPageSize, this.notificationsData.length)
                .then(this.handleGetNotificationsResult)
                .catch(this.handleError)
                .finally(() => {
                    this.isLoadingNotifications = false;
                });
        },
        handleGetNotificationsResult(result) {
            if (result?.data) {
                if (result.data.value.length > 0) {
                    this.setSoundAndIconUrls(result.data.value);

                    //Push Items to the list
                    this.NotificationsListDataSource = [...this.notificationsData, ...result.data.value];
                    this.setNotificattions(this.NotificationsListDataSource);
                }
                else {
                    this.isAllNotificationsLoaded = true;
                }
            }
        },
        setSoundAndIconUrls(notifications) {
            notifications.forEach((notification) => {
                if (notification.AlertSoundURL != null) {
                    notification.AlertSoundURL = NotificationUrl.NotificationBaseUrl + notification.AlertSoundURL;
                }

                if (notification.IconURL != null) {
                    notification.IconURL = NotificationUrl.NotificationBaseUrl + notification.IconURL;
                }
            });
        },
        handleError(error) {
            console.log(error, "Error Message");
        },
        getUnreadNotificationsCount() {
            notificationService.GetUnreadUserNotifactionsPerEntityCountPromise()
                .then(this.handleGetUnreadNotificationsCount)
                .catch(this.handleError);
        },
        handleGetUnreadNotificationsCount(result) {
            if (result?.data) {
                this.setNotificationsCounter(result.data);
            }
        },
        markNotificationsAsRead() {
            if (this.notificationsToBeReadCount > 0) {
                notificationService.MarkUserNotificationsPerEntityAsReadPromise();
            }

            this.notificationsData.forEach(notification => notification.IsRead = true);
        },
        addNotificationToList(notification) {
            if (this.isNotificationsPopupOpened == false) {
                this.setNotificationsCounter(this.notificationCounterNo + 1);
            }
            this.notificationsToBeReadCount += 1;

            this.NotificationsListDataSource = [notification, ...this.notificationsData];
            this.setNotificattions(this.NotificationsListDataSource);
        }
        //  --------------------------- END NOTIFICATIONS FUNC SECTION  --------------------------- 

    },
    mounted() {
        if (
            localStorage.getItem('NG_TRANSLATE_LANG_KEY') === 'en'
        ) {
            this.NG_TRANSLATE_LANG_KEY = this.$i18n.t('Common.En');
            document.querySelector('html').setAttribute('lang', 'en');
            document.querySelector('html').setAttribute('dir', 'ltr');
            document.querySelector('body').classList.remove('rtl', 'k-rtl');
        } else {
            this.NG_TRANSLATE_LANG_KEY = this.$i18n.t('Common.Ar');
            document.querySelector('html').setAttribute('lang', 'ar');
            document.querySelector('html').setAttribute('dir', 'rtl');
            document.querySelector('body').classList.add('rtl', 'k-rtl');
        }

        //  --------------------------- START NOTIFICATIONS MOUNTED SECTION  --------------------------- 
        //Remove dropdown when click outside on DOM
        window.addEventListener('click', this.documentClickHandler, false);

        this.bindEvent(
            window,
            "message",
            (e) => {
                // console.log(e)
                if (e.data == 'clickedOnAngularWindow') {
                    this.$refs.langMenuRef.hide(true);
                    this.$refs.userMenuRef.hide(true);
                    this.CloseNSPopover();
                }

            });
        this.$root.$on('bv::dropdown::show', () => {
            this.CloseNSPopover();
        });

        this.getTicketAndConnectToNotificationsServiceAsync();

        // Clicked for notification popover 
        this.NotificationMenuIconClick();

        window.addEventListener('beforeunload', () => {
            if (this.isNotificationsPopupOpened) {
                this.markNotificationsAsRead();
            }
        });
        //  --------------------------- END NOTIFICATIONS MOUNTED SECTION  --------------------------- 

        //  -------------------------------------------------------------------------------------------
        //  -------------------------------------------------------------------------------------------

        //  --------------------------- START UNIVERSAL SEARCH MOUNTED SECTION  --------------------------- 
        this.hidePopup()

        EventBus.$on('AddPatient-obj', patientObj => {
            if (patientObj.IsDonor == null || patientObj.IsDonor == false) {
                this.$root.$emit("PatientObjectChanged");
                this.PatientObj = patientObj;
                this.searchPatientsField = patientObj.searchPatientsField;
                this.selectedPatientCode = patientObj.selectedPatientCode;
                this.LoadFromSessionStorage()
            }
        });

        //HTML5 Method to listen for any updates at the session storage and load it at universal search
        window.addEventListener('storage', function (event) {

            if (event.key == 'patient') {
                this.LoadFromSessionStorage()
            }
        });
        this.bindEvent(window, 'storage', function (event) {

            if (event.key == 'patient') {
                this.LoadFromSessionStorage()
            }
        });


        document
            .getElementById("searchPatientsFieldControl")
            .addEventListener("keydown", this.isEnterClicked)

        $(document).on('keydown', function (e) {
            if (e.keyCode === 27) { // ESC
                this.hidePopup();
            }
            return;
        }.bind(this));

        $(window).click(function () {
            if (!this.txtBoxFocused) {
                this.hidePopup();
            }
        }.bind(this));

        //  --------------------------- END UNIVERSAL SEARCH MOUNTED SECTION  --------------------------- 


    },
    beforeDestroy() {
        this.hidePopup();
        this.removeNotificationMenuIconClick();
    },

    watch: {
        $route() {
            if (this.$router.currentRoute.fullPath.startsWith("/supply-chain") ||
                this.$router.currentRoute.fullPath.startsWith("/finance")) {
                this.searchPatient = false
                this.hidePopup()
            }
            else {
                this.searchPatient = true
                this.hidePopup()
                this.$nextTick().then(() => {
                    const searchControl = document.getElementById("searchPatientsFieldControl");
                    if (searchControl) {
                        searchControl.addEventListener("keydown", this.isEnterClicked)
                    }
                });
            }

        },
        searchPatientsField: function () {
            this.CheckDisplayCapturePatientBtn();
        },
        isNotificationsPopupOpened(val) {
            if (val) {
                this.setNotificationsCounter(0);
            }
            else {
                this.markNotificationsAsRead();
            }
        }
    },
    components: {
        capturePatient,
        notificationCardTemplate,
        Loader,
        AutoCatchBarcodeScanner
    },
    computed: {
        ...mapGetters(['geNotificattions', 'getNotificationsCounter']),

        notificationsData() {
            return this.geNotificattions;
        },
        notificationCounterNo() {
            return this.getNotificationsCounter;
        },
        ShowCounterFlag() {
            return this.notificationCounterNo > 0;
        },
        notificationsCountStr() {
            return this.notificationCounterNo <= 99 ? this.notificationCounterNo : 99 + "+";
        },
        isNotificationsButtonShown() {
            return (this.isNotificationsEnabled == true && this.hasReceiveNotificationsPermission)
        }
    }
};